<template>
    <div
            class="card-cols"
            :class="{
                'card-cols_mobile': $vuetify.breakpoint.smAndDown
            }"
    >
        <div class="card-cols__col">
            <slot name="left"></slot>
        </div>
        <div class="card-cols__vline"></div>
        <div class="card-cols__col">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss">
    .card-cols {
        display: flex;
        align-items: stretch;

        &.card-cols_mobile {
            flex-direction: column;

            .card-cols__vline {
                display: none;
            }
            .card-cols__col {
                &:last-child {
                    margin-top: 10px;
                }
            }
        }
        &.card-cols_only-right-column {
            .card-cols__col {
                &:last-child {
                    margin-top: 0 !important;
                }
            }
        }
    }
    .card-cols__col {
        flex: 1;
    }
    .card-cols__vline {
        width: 1px;
        background-color: #eee;
        margin: 0 20px;
    }
</style>